import { useState, useEffect } from 'react';
export function useAsyncHookResponse(value, loading, error) {
    var _a = useState(createNewPromise()), promise = _a[0], setPromise = _a[1];
    var _b = useState(false), complete = _b[0], setComplete = _b[1];
    useEffect(updatePromise, [loading]);
    function updatePromise() {
        if (loading && !complete)
            return;
        if (!loading && complete)
            return;
        if (loading && complete)
            setNewPromise();
        if (!loading && !complete)
            completePromise();
    }
    function completePromise() {
        if (error) {
            setComplete(true);
            promise.reject(error);
        }
        else {
            setComplete(true);
            promise.resolve(value);
        }
    }
    function setNewPromise() {
        setComplete(false);
        setPromise(createNewPromise());
    }
    function createNewPromise() {
        var resolve = function () { return null; };
        var reject = function () { return null; };
        var promise = new Promise(function (res, rej) {
            resolve = res;
            reject = rej;
        });
        return { raw: promise, resolve: resolve, reject: reject };
    }
    return [value, loading, error, promise.raw];
}
//# sourceMappingURL=use-async-hook-response.js.map